export default {
  buildBoard(rounds) {
    const squares = [];
    for (let j = 0; j < 15; j += 1) {
      squares[j] = [];
      for (let i = 0; i < 15; i += 1) {
        squares[j][i] = {
          squareType: 'normal',
          row: j,
          column: i,
          justDropped: false,
        };
      }
    }
    const tripleWord = 'tripleWord';
    const doubleWord = 'doubleWord';
    const tripleLetter = 'tripleLetter';
    const doubleLetter = 'doubleLetter';
    squares[0][0].squareType = tripleWord;
    squares[0][7].squareType = tripleWord;
    squares[0][14].squareType = tripleWord;
    squares[7][0].squareType = tripleWord;
    squares[7][14].squareType = tripleWord;
    squares[14][0].squareType = tripleWord;
    squares[14][7].squareType = tripleWord;
    squares[14][14].squareType = tripleWord;
    squares[1][1].squareType = doubleWord;
    squares[1][13].squareType = doubleWord;
    squares[2][2].squareType = doubleWord;
    squares[2][12].squareType = doubleWord;
    squares[3][3].squareType = doubleWord;
    squares[3][11].squareType = doubleWord;
    squares[4][4].squareType = doubleWord;
    squares[4][10].squareType = doubleWord;
    squares[7][7].squareType = doubleWord;
    squares[10][4].squareType = doubleWord;
    squares[10][10].squareType = doubleWord;
    squares[11][3].squareType = doubleWord;
    squares[11][11].squareType = doubleWord;
    squares[12][2].squareType = doubleWord;
    squares[12][12].squareType = doubleWord;
    squares[13][1].squareType = doubleWord;
    squares[13][13].squareType = doubleWord;
    squares[1][5].squareType = tripleLetter;
    squares[1][9].squareType = tripleLetter;
    squares[5][1].squareType = tripleLetter;
    squares[5][5].squareType = tripleLetter;
    squares[5][9].squareType = tripleLetter;
    squares[5][13].squareType = tripleLetter;
    squares[9][1].squareType = tripleLetter;
    squares[9][5].squareType = tripleLetter;
    squares[9][9].squareType = tripleLetter;
    squares[9][13].squareType = tripleLetter;
    squares[13][5].squareType = tripleLetter;
    squares[13][9].squareType = tripleLetter;
    squares[0][3].squareType = doubleLetter;
    squares[0][11].squareType = doubleLetter;
    squares[2][6].squareType = doubleLetter;
    squares[2][8].squareType = doubleLetter;
    squares[3][0].squareType = doubleLetter;
    squares[3][7].squareType = doubleLetter;
    squares[3][14].squareType = doubleLetter;
    squares[6][2].squareType = doubleLetter;
    squares[6][6].squareType = doubleLetter;
    squares[6][8].squareType = doubleLetter;
    squares[6][12].squareType = doubleLetter;
    squares[7][3].squareType = doubleLetter;
    squares[7][11].squareType = doubleLetter;
    squares[8][2].squareType = doubleLetter;
    squares[8][6].squareType = doubleLetter;
    squares[8][8].squareType = doubleLetter;
    squares[8][12].squareType = doubleLetter;
    squares[11][0].squareType = doubleLetter;
    squares[11][7].squareType = doubleLetter;
    squares[11][14].squareType = doubleLetter;
    squares[12][6].squareType = doubleLetter;
    squares[12][8].squareType = doubleLetter;
    squares[14][3].squareType = doubleLetter;
    squares[14][11].squareType = doubleLetter;

    rounds.forEach((round, index) => {
      if (round.word) {
        const location = round.word.split(' ')[0];
        const word = round.word.split(' ')[1];
        const alpha = 'ABCDEFGHIJKLMNO';
        let rowNumber;
        let colNumber;
        const horizontal = isNaN(location.charAt(0));
        if (location.length === 2 && !isNaN(location.charAt(0))) {
          colNumber = parseInt(location.charAt(0), 10) - 1;
          rowNumber = alpha.indexOf(location.charAt(1));
        } else if (location.length === 3 && !isNaN(location.charAt(0))) {
          colNumber = parseInt(location.substring(0, 2), 10) - 1;
          rowNumber = alpha.indexOf(location.charAt(2));
        } else if (location.length === 2 && isNaN(location.charAt(0))) {
          colNumber = parseInt(location.charAt(1), 10) - 1;
          rowNumber = alpha.indexOf(location.charAt(0));
        } else if (location.length === 3 && isNaN(location.charAt(0))) {
          colNumber = parseInt(location.substring(1, 3), 10) - 1;
          rowNumber = alpha.indexOf(location.charAt(0));
        }
        let joker = false;
        const lastRound = index === rounds.length - 1;
        [...word].forEach((letter) => {
          if (letter !== '(' && letter !== ')') {
            if (!squares[rowNumber][colNumber].droppedTile) {
              if (joker) {
                squares[rowNumber][colNumber].droppedTile = {
                  value: letter,
                  lastRound,
                  tile: {
                    value: '?',
                    point: 0,
                  },
                };
              } else {
                squares[rowNumber][colNumber].droppedTile = {
                  value: letter,
                  lastRound,
                  tile: {
                    value: letter,
                    point: this.letterToPoint(letter),
                  },
                };
              }
              squares[rowNumber][colNumber].droppedRound = index + 1;
            }
            if (horizontal) {
              colNumber += 1;
            } else {
              rowNumber += 1;
            }
          }
          joker = letter === '(';
        });
      }
    });
    return {
      squares,
    };
  },
  letterToPoint(letter) {
    const r = {
      A: 1,
      B: 3,
      C: 3,
      D: 2,
      E: 1,
      F: 4,
      G: 2,
      H: 4,
      I: 1,
      J: 8,
      K: 10,
      L: 1,
      M: 2,
      N: 1,
      O: 1,
      P: 3,
      Q: 8,
      R: 1,
      S: 1,
      T: 1,
      U: 1,
      V: 4,
      W: 10,
      X: 10,
      Y: 10,
      Z: 10,
      '?': 0,
    };
    return r[letter];
  },
  buildDraw(round) {
    return round
      ? [...round.draw].map((letter, index) => ({
        drawIndex: index,
        value: letter,
        tile: {
          value: letter,
          point: this.letterToPoint(letter),
        },
      }),
      )
      : undefined;
  },
  deck() {
    const tiles = (letter, occurs) => [...Array(occurs)].map(() => letter);
    return [].concat(tiles('A', 9),
      tiles('B', 2),
      tiles('C', 2),
      tiles('D', 3),
      tiles('E', 15),
      tiles('F', 2),
      tiles('G', 2),
      tiles('H', 2),
      tiles('I', 8),
      tiles('J', 1),
      tiles('K', 1),
      tiles('L', 5),
      tiles('M', 3),
      tiles('N', 6),
      tiles('O', 6),
      tiles('P', 2),
      tiles('Q', 1),
      tiles('R', 6),
      tiles('S', 6),
      tiles('T', 6),
      tiles('U', 6),
      tiles('V', 2),
      tiles('W', 1),
      tiles('X', 1),
      tiles('Y', 1),
      tiles('Z', 1),
      tiles('?', 2));
  },
  buildDeck(board, draw) {
    const result = this.deck();
    if (board) {
      board.squares.reduce((acc, el) => acc.concat(el), [])
        .filter(s => s.droppedTile)
        .map(s => s.droppedTile.tile.value)
        .forEach(l => result.splice(result.indexOf(l), 1));
    }
    if (draw) {
      draw.forEach((d) => {
        result.splice(result.indexOf(d.tile.value), 1);
      });
    }
    return result;
  },
};



// WEBPACK FOOTER //
// ./src/components/games/BoardUtils.js